import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './aci.scss';
import { getModuleFromPath } from './aciData.js';
import ACIHub from './Hub/index.jsx';
import UserManagement from './UserManagement/index.jsx';
import UserAnalytics from './UserAnalytics/index.jsx';

export class ACIComponent extends React.Component {
    renderModule() {
        const module = getModuleFromPath(this.props.location.pathname);

        switch (module) {
            case 'user-management':
                return <UserManagement />;
            case 'user-analytics':
                return <UserAnalytics />;
            case 'hub':
            default:
                return <ACIHub />;
        }
    }

    render() {
        return (
            <div className="aci-page page-content">
                {this.renderModule()}
            </div>
        );
    }
}

export default withRouter(connect(
    (state) => ({
        authReducer: state.authReducer,
    })
)(ACIComponent));
